import { AttributeText } from 'src/graphql/entities/custom-attributes/field-view-registry/components/attribute-text';
import { EmptyValue } from 'src/graphql/entities/custom-attributes/field-view-registry/components/empty-value';
import { CustomAttributeReadProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import {
  getAttributeOptionLabel,
  getKindLikeValueSafely,
} from 'src/graphql/entities/custom-attributes/field-view-registry/utils';

export const DropdownView = ({ value, definition }: CustomAttributeReadProps) => {
  const selectedValue = getKindLikeValueSafely(value, 'dropdown');

  if (!selectedValue) {
    return <EmptyValue />;
  }

  return (
    <AttributeText>{getAttributeOptionLabel(definition.options, selectedValue)}</AttributeText>
  );
};
